import { render, staticRenderFns } from "./ExerciseCourseCpnt.vue?vue&type=template&id=2033fd52&"
import script from "@/scripts/MainMode/MainModeCourse/ExerciseCourseCpnt/index.js?vue&type=script&lang=js&"
export * from "@/scripts/MainMode/MainModeCourse/ExerciseCourseCpnt/index.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports